var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Up",
    transform: "translate(-192 -16)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_249",
    "data-name": "Ellipse 249",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(201 25) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "caret-up",
    d: "M97.318,151.074l-2.232,2.605a.383.383,0,0,1-.582,0l-2.232-2.605a.383.383,0,0,1,.291-.633h4.466A.383.383,0,0,1,97.318,151.074Z",
    transform: "translate(291.287 172.627) rotate(-180)",
    fill: "#1450ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpBlueIcon);
export default __webpack_public_path__ + "static/media/up-blue-icon.257b17221293f4dcd09a8eee090cf764.svg";
export { ForwardRef as ReactComponent };